import { render, staticRenderFns } from "./AiActionWrapper.vue?vue&type=template&id=72dfd2a6"
import script from "./AiActionWrapper.vue?vue&type=script&lang=js"
export * from "./AiActionWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports